/** Dashboard 双栏侧栏：一级轨 + 二级面板（页脚分组见 footerNavGroups.js） */
export const DASHBOARD_NAV_CATEGORIES = [
  {
    id: 'lip-sync',
    labelKey: 'navLipSync',
    icon: 'videoPlay',
    panelTitleKey: 'navLipSync',
    groups: [
      {
        groupKey: 'lipsync',
        items: [
          { labelKey: 'lipsync', to: '/', icon: 'videoPlay' },
          { labelKey: 'aiTalkingPhoto', to: '/talking-photo-ai', icon: 'micIcon' },
          { labelKey: 'aiTalkingAnimals', to: '/talking-animals', icon: 'animalsCatIcon' },
          { labelKey: 'aiTalkingCartoon', to: '/talking-cartoon', icon: 'talkingCartoonIcon' },
          { labelKey: 'aiInfluencer', to: '/ai-influencer-generator', icon: 'influencerIcon' },
          { labelKey: 'aiBabyPodcast', to: '/ai-baby-podcast', icon: 'babyFaceIcon' },
          { labelKey: 'aiTalkingAvatar', to: '/talking-avatar', icon: 'talkingPhotoIcon' },
          { labelKey: 'aiNewsAnchor', to: '/ai-news-anchor', icon: 'newsAnchorIcon' },
          { labelKey: 'avatarDialogue', to: '/avatar-dialogue', icon: 'talkingChatIcon' },
          { labelKey: 'aiBabyTalking', to: '/baby-talking', icon: 'babyTalkingIcon' },
          { labelKey: 'aiDubbing', to: '/ai-dubbing', icon: 'shengboIcon' },
        ],
      },
    ],
  },
  {
    id: 'singing-photo',
    labelKey: 'navSectionSingingPhoto',
    icon: 'micSigningIcon',
    panelTitleKey: 'navSectionSingingPhoto',
    groups: [
      {
        groupKey: 'navGroupSingTools',
        items: [
          { labelKey: 'aiSingingPhoto', to: '/ai-singing-photo', icon: 'micSigningIcon' },
          { labelKey: 'singCartoon', to: '/cartoon-singing', icon: 'cartoonSingingIcon' },
          { labelKey: 'babySinging', to: '/baby-singing', icon: 'babySingingIcon' },
        ],
      },
    ],
  },
  {
    id: 'ai-video',
    labelKey: 'navSectionAiVideo',
    icon: 'videoPlay',
    panelTitleKey: 'navSectionAiVideo',
    groups: [
      {
        groupKey: 'navGroupAiVideo',
        items: [{ labelKey: 'aiImageToVideo', to: '/ai-image-to-video', icon: 'photo' }],
      },
    ],
  },
  {
    id: 'ai-avatar',
    labelKey: 'navSectionAiAvatar',
    icon: 'uploadAvatar',
    panelTitleKey: 'navSectionAiAvatar',
    groups: [
      {
        groupKey: 'navSectionAiAvatar',
        items: [
          { labelKey: 'aiAvatarGenerator', to: '/ai-avatar-generator', icon: 'talkingPhotoIcon' },
          { labelKey: 'aiHumanGenerator', to: '/ai-human-generator', icon: 'humanAvatarIcon' },
          { labelKey: 'productAvatarGenerator', to: '/product-avatar', icon: 'productAvatarIcon' },
        ],
      },
    ],
  },
  {
    id: 'ai-image',
    labelKey: 'aiImage',
    icon: 'photo',
    panelTitleKey: 'aiImage',
    groups: [
      {
        groupKey: 'navSectionAiAvatar',
        items: [{ labelKey: 'aiImageGenerator', to: '/ai-image-generator', icon: 'photo' }],
      },
    ],
  },
  {
    id: 'ai-audio',
    labelKey: 'navSectionAiAudio',
    icon: 'audioWaveIcon',
    panelTitleKey: 'navSectionAiAudio',
    groups: [
      {
        groupKey: 'navGroupAiAudio',
        items: [
          { labelKey: 'aiVoiceCloning', to: '/voice-cloning', icon: 'audioWaveIcon' },
          { labelKey: 'audioCleaner', to: '/audio-cleaner', icon: 'audioCleanerIcon' },
          { labelKey: 'audioEnhancer', to: '/audio-enhancer', icon: 'audioEnhancerIcon' },
        ],
      },
    ],
  },
]

export const DASHBOARD_CREATION_LINK = {
  labelKey: 'myCreations',
  to: '/my-creations',
  icon: 'creation',
}

/** @deprecated 使用 DASHBOARD_NAV_CATEGORIES */
export const DASHBOARD_NAV_SECTIONS = DASHBOARD_NAV_CATEGORIES

export const DASHBOARD_UTILITY_NAV_LINKS = [DASHBOARD_CREATION_LINK]

export const DASHBOARD_PRIMARY_NAV_LINKS = [
  ...DASHBOARD_NAV_CATEGORIES.flatMap((category) =>
    category.groups.flatMap((group) => group.items),
  ),
  ...DASHBOARD_UTILITY_NAV_LINKS,
]
